if (!customElements.get("flavor-swatch")) {
  class FlavorSwatch extends HTMLElement {
    constructor() {
      super();
      this.instanceId = Math.random().toString(36).substring(7);
      this.handleChange = this.handleSwatchChange.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector("form[data-swatch-form]");
      this.inputs = this.form?.querySelectorAll("input[data-swatch-input]");
      if (!this.inputs || !this.form) return;

      this.inputs?.forEach((input) => {
        input.addEventListener("change", this.handleChange);
      });

      // Only initialize once
      if (this.hasAttribute("data-swatch-initialized")) {
        return;
      }

      this.setAttribute("data-swatch-initialized", "true");
      this.setAttribute("data-swatch-instance", this.instanceId);
    }

    handleSwatchChange(e) {
      const input = e.target;

      // find the parent element with the data-swatch-item attribute
      const swatchItem = input.closest("[data-swatch-item]");

      // check if the selected flavor text exists
      const selectedFlavorText = swatchItem.querySelector(".selected-flavor");
      if (selectedFlavorText) {
        selectedFlavorText.textContent = input.value;
      }

      // then find the image within it and update the src
      const swatchImage = swatchItem
        .querySelector("[data-variant-image-change]")
        ?.querySelector("img");

      if (swatchImage && input.dataset.variantImage) {
        swatchImage.src = input.dataset.variantImage;
        // Also update srcset if it exists
        if (swatchImage.srcset) {
          swatchImage.srcset = input.dataset.variantImage;
        }
      }

      // update the price
      const priceElement = swatchItem.querySelector(
        ".price"
      );
      if (priceElement) {
        // round up the price to the nearest dollar (with js)
        const price = Number(input.dataset.variantPrice?.replace("$", ""));
        const roundedPrice = Math.ceil(price) * 100;
        console.log({
          variantPrice: input.dataset.variantPrice,
          price,
          roundedPrice,
        });
        priceElement.textContent = Shopify.formatMoney(roundedPrice).replace(".00", "");
      }
    }
  }
  customElements.define("flavor-swatch", FlavorSwatch);
}
